import { render } from "./budgetCitizen.vue?vue&type=template&id=506e461b&scoped=true"
import script from "./budgetCitizen.vue?vue&type=script&lang=js"
export * from "./budgetCitizen.vue?vue&type=script&lang=js"

import "./budgetCitizen.vue?vue&type=style&index=0&id=506e461b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506e461b"]])

export default __exports__